// @ts-nocheck
import {Routes} from '@angular/router';

export const NG_DOC_ROUTING: Routes = [
	{
		path: 'api',
		loadChildren: () => import('.ng-doc/m-docs/api/api/ng-doc-api-list.module').then(m => m.DynamicModule)
	},
	{
		path: 'angular-materiel',
		loadChildren: () => import('.ng-doc/m-docs/guides/angular-materiel/module').then(m => m.DynamicModule)
	},
	{
		path: 'getting-started',
		loadChildren: () => import('.ng-doc/m-docs/guides/getting-started/module').then(m => m.DynamicModule)
	},
	{
		path: 'm-theme',
		loadChildren: () => import('.ng-doc/m-docs/guides/m-theme/module').then(m => m.DynamicModule)
	},
	{
		path: 'm-ui',
		loadChildren: () => import('.ng-doc/m-docs/guides/m-ui/module').then(m => m.DynamicModule)
	},
	{
		path: 'others',
		loadChildren: () => import('.ng-doc/m-docs/guides/others/module').then(m => m.DynamicModule)
	},
];
